@if (localized()) {
  <div class="required" class="p-error  text-xs mb-0">
    @if (errors() && errors().required) {
      <div class="p-error mt-1 validationerror">{{'common.errors.validations.REQUIRED' | translate : {fieldlabel:fieldLabel()} }}</div>
    }
    @if (errors() && errors().email) {
      <div class="p-error mt-1 validationerror">{{'common.errors.validations.EMAIL' | translate}}</div>
    }
    @if (errors() && errors().minlength) {
      <div class="p-error mt-1 validationerror">{{'common.errors.validations.MINLENGTH' | translate : {minlength:errors().minlength.requiredLength} }}</div>
    }
    @if (errors() && errors().maxlength) {
      <div class="p-error mt-1 validationerror">{{'common.errors.validations.MAXLENGTH' | translate : {maxlength:errors().maxlength.requiredLength} }}</div>
    }
    @if (errors() && errors().matching) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.PASSWORD-NOT-MATCHED' | translate}}</div>
    }
    @if (errors() && errors().wrongText) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.CONFIRMATION-TEXT' | translate}}</div>
    }
    @if (errors() && errors().minimumNumericalCheck) {
      <div  class="p-error mt-1  validationerror">{{'common.errors.validations.PASSWORD_NUMBER' | translate}}</div>
    }
    @if (errors() && errors().specialCharacterCheck) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.PASSWORD_SPECIAL_CHAR' | translate}}</div>
    }
    @if (errors() && errors().specialIpAddressCheck) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.IP_ADDRESS' | translate}}</div>
    }
    @if (errors() && errors().decimalNumberLimit) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.VALID_DECIMAL' | translate}}</div>
    }
    @if (errors() && errors().pattern) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.PATTERN' | translate}}</div>
    }
    @if (errors() && errors().lowercaseCharacterCheck) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.PASSWORD_LOWERCASE_CHAR' | translate}}</div>
    }
    @if (errors() && errors().uppercaseCharacterCheck) {
      <div  class="p-error mt-1 validationerror">{{'common.errors.validations.PASSWORD_UPPERCASE_CHAR' | translate}}</div>
    }
    @if (errors() && errors().duplicate) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.Duplicate' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().fromToDate) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.FromToDate' | translate : {fieldlabel:fieldLabel(),secondFieldLabel:secondFieldLabel()} }}</span>
    }
    @if (errors() && errors().ccNumber) {
      <span  class="p-error mt-1 validationerror">{{'POS.MEMBERSHIP_ADDON.CCNUMBER' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().expDate) {
      <span  class="p-error mt-1 validationerror">{{'POS.MEMBERSHIP_ADDON.CCEXPIRYDATE' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().mobileNumberCheck) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.PHONE_NUMBER' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().validatePhoneNumber && !errors().validatePhoneNumber.valid) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.PHONE_NUMBER' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().nationalIdCheck && !errors().required) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.INVALID_NATIONAL_ID' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().duplicates && !errors().required) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.INVALID_NATIONAL_ID' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
    @if (errors() && errors().overlaps && !errors().required) {
      <span  class="p-error mt-1 validationerror">{{'common.errors.validations.INVALID_NATIONAL_ID' | translate : {fieldlabel:fieldLabel()} }}</span>
    }
  </div>
} @else {
  <div class="required" class="p-error  text-xs mb-0" >
    @if (errors() && errors().required) {
      <div class="p-error mt-1 validationerror">{{fieldLabel()}} is required </div>
    }
    @if (errors() && errors().validatePhoneNumber && !errors().validatePhoneNumber.valid) {
      <span  class="p-error mt-1 validationerror">{{fieldLabel()}} is not valid.</span>
    }
  </div>
}

